import { render } from "./PeerProfileCard.vue?vue&type=template&id=7f17e2f5"
import script from "./PeerProfileCard.vue?vue&type=script&lang=js"
export * from "./PeerProfileCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__